import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@lib/services/auth-service.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isInitLogin()) {
    return router.createUrlTree(['/init']);
  }

  if (auth.isBackOffice() || !auth.isAuthenticated()) {
    return router.createUrlTree(['/unauthorized']);
  }

  return true;
};

// should not display init page if already logged in
export const InitGuard: CanActivateFn = (route, state) => {
  if (!inject(AuthService).isInitLogin()) {
    inject(Router).navigate(['']);
  }
  return true;
};
